import React, { useMemo } from "react";

import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import LogoutIcon from "@mui/icons-material/Logout";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import EngineeringIcon from "@mui/icons-material/Engineering";
import HandymanIcon from "@mui/icons-material/Handyman";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import GroupsIcon from "@mui/icons-material/Groups";
import { useTheme } from "@emotion/react";

const CardIconWithText = React.memo((props) => {
  const theme = useTheme();

  const chooseIcon = () => {
    const fontSize = "large";
    switch (props.icon) {
      case "LogoutIcon":
        return (
          <LogoutIcon fontSize={fontSize} style={{ ...props.iconStyle }} />
        );
      case "ApartmentIcon":
        return (
          <ApartmentIcon fontSize={fontSize} style={{ ...props.iconStyle }} />
        );
      case "HandshakeIcon":
        return (
          <HandshakeIcon fontSize={fontSize} style={{ ...props.iconStyle }} />
        );
      case "DesignServicesIcon":
        return (
          <DesignServicesIcon
            fontSize={fontSize}
            style={{ ...props.iconStyle }}
          />
        );
      case "EngineeringIcon":
        return (
          <EngineeringIcon fontSize={fontSize} style={{ ...props.iconStyle }} />
        );
      case "HandymanIcon":
        return (
          <HandymanIcon fontSize={fontSize} style={{ ...props.iconStyle }} />
        );
      case "AdminPanelSettingsIcon":
        return <AdminPanelSettingsIcon fontSize={fontSize} style={{ ...props.iconStyle }} />;
      case "BusinessCenterIcon":
        return (
          <BusinessCenterIcon
            fontSize={fontSize}
            style={{ ...props.iconStyle }}
          />
        );
      case "GroupsIcon":
        return (
          <GroupsIcon fontSize={fontSize} style={{ ...props.iconStyle }} />
        );
      default:
        return null;
    }
  };

  const getIcon = useMemo(() => {
    if (React.isValidElement(props.icon)) {
      return props.icon;
    }
    return chooseIcon();
  }, [props.icon]);

  return (
    <Card
      sx={{
        color: "#FFFFFF",
        background: props.isSelected ? theme.palette.primary.light : "grey",
      }}
    >
      <CardActionArea
        sx={{ padding: 1, ...props.cardAreaStyle }}
        onClick={props.onClick}
      >
        <Grid container>
          <Grid item xs={props.inLine ? 4 : 12}>
            {getIcon}
          </Grid>
          <Grid item xs={!props.icon ? 12 : props.inLine ? 8 : 12}>
            <CardContent sx={{ padding: "0 !important" }}>
              <Typography
                variant={props.textVariant}
                sx={{
                  ...props.textSx,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {props.label}
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </CardActionArea>
    </Card>
  );
});

CardIconWithText.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.oneOfType(PropTypes.string, PropTypes.element),
  isSelected: PropTypes.bool,
  cardAreaStyle: PropTypes.object,
  textVariant: PropTypes.string,
  textSx: PropTypes.object,
  iconStyle: PropTypes.object,
  inLine: PropTypes.bool,
};

CardIconWithText.defaultProps = {
  categories: [],
  isSelected: false,
  textVariant: "body1",
  textSx: {},
  iconStyle: {},
  inLine: false,
};

export default CardIconWithText;
